import { render, staticRenderFns } from "./LivesImpactedPill.vue?vue&type=template&id=3dacb925&"
import script from "./LivesImpactedPill.vue?vue&type=script&lang=js&"
export * from "./LivesImpactedPill.vue?vue&type=script&lang=js&"
import style0 from "./LivesImpactedPill.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports